module.exports = __webpack_public_path__ + "img/simple.c0bf5d7.svg";